module.exports = __webpack_public_path__ + "img/comercial.81a8f123.svg";